module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-page-content"
  }, [_c('FeatureProducts'), _vm._v(" "), _vm._l((_vm.items), function(widget) {
    return _c('div', {
      key: widget.Id,
      staticClass: "widget",
      attrs: {
        "data-Name": widget.Name
      },
      domProps: {
        "innerHTML": _vm._s(widget.Body)
      }
    })
  }), _vm._v(" "), _c('home-article'), _vm._v(" "), _c('faqs')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf061bf6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/Home.vue
// module id = 487
// module chunks = 1